import React from 'react';

function SupportMaterialListing(props) {

    return (
        <>
            <article className="material material-row">
                <div className="material-info">
                    <div className="flex-container">
                        <div className="column-info">
                            <div className="material-status">
                                <span className="material-text">{props.result.category}</span>
                            </div>
                            <h5 className="material-name">
                                {props.result.name}
                            </h5>
                            <p className="material-summary">
                                {props.result.short_description}
                            </p>
                            { (props.result.related_searches.length > 0) &&
                                <>
                                    <span className="related-search-label">Related Search:</span> 
                                    {Object.entries(props.result.related_searches).map(([index, phrase]) => (
                                        <>
                                            <a className="related-search" onClick={(e) => props.handleRecommendedSearchClick(e, phrase)}>{phrase}</a>
                                        </>
                                    ))}
                                </>
                            }
                        </div>
                        <div className="column-action">
                            <div class="right--block">
                                { props.result.restricted ? 
                                    <>
                                        { props.result.restricted_message.length > 0 ?
                                            <>
                                                <i>{props.result.restricted_message}</i>
                                            </>
                                            :
                                            <>
                                                <i>{props.defaultRestrictedContentMessage}</i>
                                            </>
                                        }
                                    </>
                                    :
                                    <>
                                        <div className="link-type">
                                            { (props.result.type === "link" && props.result.link_type === "webpage") &&
                                                <>
                                                    <span className="material-text">External Site</span> <img class="external-link" src="/wp-content/themes/kois-2017-web/img/icon-external-site.svg" />
                                                </>
                                            }
                                            { (props.result.type === "link" && props.result.link_type === "video") &&
                                                <>
                                                    <span className="material-text">Video</span> <img src="/wp-content/themes/kois-2017-web/img/icon-video.svg" />
                                                </>
                                            }
                                            { (props.result.type === "document") &&
                                                <>
                                                    { (props.result.document_type === "ppt") &&
                                                        <>
                                                            <span className="material-text">PPT</span>
                                                        </>
                                                    }
                                                    { (props.result.document_type === "pptx") &&
                                                        <>
                                                            <span className="material-text">PPT</span>
                                                        </>
                                                    }
                                                    { (props.result.document_type === "pdf") &&
                                                        <>
                                                            <span className="material-text">PDF</span>
                                                        </>
                                                    }
                                                    <img src="/wp-content/themes/kois-2017-web/img/icon-download.svg" />
                                                </>
                                            }
                                        </div>
                                        { (props.result.type === "link" && props.result.link_type !== "video") &&
                                            <>
                                                <a href={props.result.link_href} target={props.result.link_target} class="course--link btn c-btn--light">Visit Website</a>
                                            </>
                                        }
                                        { (props.result.type === "link" && props.result.link_type === "video") &&
                                            <>
                                                <a href={props.result.link_href} target={props.result.link_target} class="course--link btn c-btn--light">Watch Video</a>
                                            </>
                                        }
                                        { (props.result.type === "document") &&
                                            <>
                                                <a href={props.result.link_href} class="course--link btn c-btn--light">Download</a>
                                            </>
                                        }
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </>
    );
}

export default SupportMaterialListing;